import { styled } from 'styled-components';

export const PhoneWrapper = styled.div`
  position: relative;
  font-size: 18px;
  line-height: 22px;
  font-weight: 400;
  font-family: var(--base-font-sans-serif);
  label {
    display: block;
    margin-bottom: 10px;
  }
  .PhoneInput {
    background: #f1f1f1;
    border: ${({ $invalid }) => $invalid && '1px solid var(--danger)'};
    border-radius: 60px;
  }
  .PhoneInput--focus {
    box-shadow: none;
  }
  .PhoneInputCountrySelect:focus + .PhoneInputCountryIcon--border {
    box-shadow: none;
  }
  .PhoneInputCountry {
    border-radius: 100px;
    width: 55px;
    display: flex;
    justify-content: flex-end;
    flex-shrink: 0;

    .PhoneInputCountryIcon {
      box-shadow: none;
      overflow: hidden;
      width: 25px;
      height: 16px;
      &:focus {
        box-shadow: none;
      }
      img {
        width: 100%;
        object-fit: cover;
      }
    }
  }
  .PhoneInputCountrySelect {
    font-family: var(--base-font-sans-serif);
    option {
      font-size: 14px;
      line-height: 18px;
    }
  }
  .PhoneInputCountrySelectArrow {
    width: 0;
    height: 0;
    border-radius: 2px;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #313131;
    border-bottom: none;
    opacity: 1;
    transform: none;
  }
  input {
    height: 45px;
    border-radius: 100px;
    border: none;
    padding: 0 0 0 10px;
    font-size: 16px;
    line-height: 19px;
    outline: none;
    margin: 0 !important;
    background: #f1f1f1;
    font-weight: 400;
    &::placeholder {
      color: var(--light-gray);
    }
  }
  .error {
    font-size: 12px;
    line-height: 14px;
    font-weight: 400;
    position: absolute;
    left: 5px;
    bottom: -15px;
    color: var(--danger);
    p {
      margin: 0;
    }
  }
`;
